module.exports = __webpack_public_path__ + "static/media/CSTT.ca807f0c.jpeg";